import React from 'react'
import styled from 'styled-components'

import { useTranslate } from '@tolgee/react';
import { ReactComponent as Search } from "../../Assets/iconsv2/generic/search.svg"

const SearchMenu = ({ value, setvalue }) => {

    const handleInputChange = (e) => {
        setvalue(e.target.value)
    }
    const handleEsc = (e) => {
        if (e.key === "Escape") {
            setvalue("")
        }
    }
    const { t } = useTranslate();
    return (

        <SearchWrapper>
            <Search />
            <SearchInput
                onKeyDown={(e) => handleEsc(e)}
                value={value}
                placeholder={t('general.search')}
                onChange={(e) => handleInputChange(e)}
            />
        </SearchWrapper>
    )
}

export default SearchMenu
const SearchWrapper = styled.div`
display:flex;
align-items:center;
padding:12px 8px;
border:1px solid ${({ theme }) => theme.sidebar.borderColor};
border-radius:4px;
gap:8px;
background:${({ theme }) => theme.menu.background};
width:100%;
`
const SearchInput = styled.input`
border:none;
background:none;
color:${({ theme }) => theme.menu.secondaryTextColor};
font-weight: 500;
font-size: 16px;
line-height: 100%;
letter-spacing: 0.04px;
vertical-align: middle;
width:100%;
outline:none;

&::placeholder{
font-weight:400;
}
`